// @flow
import React from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import BannerViewer from 'containers/banner/BannerViewer';
import { type Match } from 'react-router-dom';
import BannerCommentsContainer from 'containers/banner/BannerCommentsContainer';
import BannerSequencesContainer from 'containers/banner/BannerSequencesContainer';
import PlainTemplate from 'components/common/PlainTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Banner = ({ match }: Props) => {
  const { username, urlSlug } = match.params;

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PlainTemplate>
        <BannerViewer username={username} urlSlug={decodeURI(urlSlug || '')} />
        <BannerCommentsContainer />
      </PlainTemplate>
      <BannerSequencesContainer username={username || ''} />
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/pages/Banner.js